import { DayOffSupervisor } from 'features/dayOffSubordinates';
import { useTitle } from '../helpers';

/**
 * @page DayOffSupervisorPage page
 */
const DayOffSupervisorPage = () => {
  useTitle('Отгулы подчиненных');

  return (
    <div>
      <DayOffSupervisor />
    </div>
  );
};

export default DayOffSupervisorPage;
